// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/OperationBtn2.less
// module id = 934
// module chunks = 0